<template>
  <div>
    <img class="bg" :src="require('@/assets/images/login-page/wel_bg.png')" alt="">
    <img class="logo" :src="require('@/assets/images/login-page/logo.png')" alt="">
    <img class="text" :src="require('@/assets/images/login-page/wel_text.png')" alt="">
  </div>
</template>

<script>
export default {
  mounted () {
    setTimeout(() => {
      this.$router.push('/home')
    }, 3000)
  }
}
</script>

<style lang="less" scoped>
  .bg {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }
  .logo {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 266px;
    height: 269px;
    object-fit: cover;
  }
  .text {
    position: absolute;
    z-index: 3;
    left: 50%;
    bottom: 111px;
    transform: translateX(-50%);
    width: 411px;
    height: 51px;
    object-fit: cover;
  }
</style>
